var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'awards';

var	DEFAULTS = {
	itemSelector: '',
	controlButtonClassName: '',
	controlButtonWrapperClassName: '',
	messages: {
		show: 'Ukaž víc',
		hide: 'Ukaž méně'
	}
};

var Awards = function (selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.initialise_();
};

Awards.prototype.initialise_ = function() {
	this.$items = $(this.options.itemSelector, this.$t);
	if (this.$items.size() < 2) {
		return false;
	}

	this.initHide_();
	this.renderControlButton_();
	this.bindControlButton_();

};

Awards.prototype.initHide_ = function() {
	$.each(this.$items, function(index, item) {
		if (index > 0) {
			$(item).hide();
		}
	});
};

Awards.prototype.renderControlButton_ = function() {
	this.$controlButtonWrapper = $('<p class="'+this.options.controlButtonWrapperClassName+'"></p>').appendTo(this.$t);
	this.$controlButton = $('<a href="javascript:void(0)" class="'+ this.options.controlButtonClassName+'">'+this.options.messages.show+'</a>').appendTo(this.$controlButtonWrapper);
};

Awards.prototype.bindControlButton_ = function() {
	var self_ = this;
	this.$controlButton.on('click', function(event) {
		event.preventDefault();
		$.each(self_.$items, function(index, item) {
			if (index > 0) {
				$(item).slideToggle();
			}
		});

		if ($(event.currentTarget).text() === self_.options.messages.show) {
			$(event.currentTarget).text(self_.options.messages.hide);
		} else {
			$(event.currentTarget).text(self_.options.messages.show);
		}
	});
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new Awards(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.awards.js